<template>
  <div class="personal-popup" v-if="!isH5">
    <el-floating
      :visible.sync="showModal"
      :width="'470px'"
      :title="$t('个人资料')"
      custom-class="personal-floating el-floating_d-reset"
      @close="closeDrawer"
      :append-to-body="true"
    >
      <PersonalContent @close="closeDrawer" v-if="showModal" />
    </el-floating>
  </div>
</template>

<script>
import PersonalContent from './personalContent.vue';
import { mapState } from 'vuex';
export default {
  components: {
    PersonalContent,
  },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
  },
  watch: {
    value(val) {
      this.showModal = val;
      if (val) {
        this.$trackEvent({
          eventId: 'sailing_c_x_profile_common_sw',
          eventLabel: '个人页面展示',
        });
      }
    },
    showModal(val) {
      this.$emit('input', val);
    },
  },
  mounted() {},
  methods: {
    closeDrawer() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss">
.personal-floating {
  padding: 0 24px;
}
</style>